module.exports = __webpack_public_path__ + "static/media/20_l_stena_0_0.37875a0f.png";